import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

const PicturesDisplay = ({ images }) => {
  return (
    <div
      css={{
        display: 'flex',
        gap: 10,
        justifyContent: 'center',
        margin: 'auto',
        marginTop: 25,
        maxHeight: 200,
        width: '100%',
      }}
    >
      {images.map((item) => {
        return (
          <GatsbyImage
            key={item.images.fallback.src}
            alt="Etudiants du Reacteur"
            image={item}
            css={{
              aspectRatio: '3/2',
              width: 'calc((100% - 20px)/3)',
              borderRadius: 5,
              overflow: 'hidden',
            }}
          />
        );
      })}
    </div>
  );
};

export default PicturesDisplay;
